// https://nextjs.org/docs/app/api-reference/functions/generate-metadata#link-relpreload
'use client';

import { preload } from 'react-dom';
export var PreloadResources = function PreloadResources() {
  preload('https://static.crehana.com/static/fonts/compass/poppins/semibold/poppins-v20-latin-600.72993dddf88a.woff2', {
    as: 'font',
    crossOrigin: 'cors'
  });
  preload('https://static.crehana.com/static/fonts/compass/poppins/regular/poppins-v20-latin-regular.9212f6f9860f.woff2', {
    as: 'font',
    crossOrigin: 'cors'
  });
  preload('https://static.crehana.com/static/fonts/compass/poppins/bold/Poppins-Bold.d9d4f92e841a.woff2', {
    as: 'font',
    crossOrigin: 'cors'
  });
  return null;
};